<template>
    <MainContent title="Detalle de la acreditación">
        <template v-slot:header>
            <h1>{{ 'Datos de la acreditación Nº ' + acreditacion_id }}</h1>
        </template>
        <template v-slot:content>
            <div v-if="!loading">
                <b-list-group-item>
                    <b>Nombre: </b> {{ acreditacion.nombre }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>DNI </b> {{ acreditacion.dni }}  
                </b-list-group-item>
                <b-list-group-item>
                    <b>Medio: </b> <a>{{ acreditacion.medio }}</a>
                </b-list-group-item>
                <b-list-group-item>
                    <b>Código QR: </b> <a>{{ acreditacion.qr_code }}</a>
                </b-list-group-item>
                <b-list-group-item>
                    <b>Puertas: </b> <a>{{ acreditacion.puertasSelect.map(i => i.nombre).join(', ') }}</a>
                </b-list-group-item>
                <b-list-group-item>
                    <b>Staff, servicios, prensa...: </b><div v-html="acreditacion.servicios"></div>
                </b-list-group-item>
                <b-list-group-item>
                    <b>Jornada: </b><div v-html="acreditacion.jornada"></div>
                </b-list-group-item>
                <b-list-group-item>
                    <b>Acceso zonas: </b><div v-html="acreditacion.acceso_zonas"></div>
                </b-list-group-item>
                <b-list-group-item>
                    <b>Observaciones: </b><div v-html="acreditacion.observaciones"></div>
                </b-list-group-item>
                <b-list-group-item>
                    <b>Condiciones: </b><div v-html="acreditacion.condiciones"></div>
                </b-list-group-item>
            </div>
            <LoaderComponent v-else></LoaderComponent>
        </template>
    </MainContent>
</template>

<script>
import MainContent from '@/components/backend/components/MainContent';

export default {
    props: ['evento_id', 'acreditacion_id'],
    data() {
        return {
            loading: false,
            acreditacion: null
        }
    },
    methods: {
        getAcreditacion() {
            this.loading = true;

            const params = {
                filters: {},
                evento_id: this.evento_id,
                acreditacion_id: this.acreditacion_id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.events.acreditaciones.show'), params).then(res => {
                this.acreditacion = res.data.data;
                this.loading = false;
            });
        },
    },
    created() {
        this.getAcreditacion();
    },
    components: {
        MainContent
    }
}
</script>